import { User } from 'hooks/use-user'
import { getMonthlyTier1PriceExperimentEnabled } from 'utils/get-user-super-properties'
import {
  getGrowthbookUserId,
  growthbookFeatures,
  growthBook,
} from 'utils/growthbook'
import { isWithinDateRange } from 'utils/isWithinDateRange'
import { Mixpanel, MIXPANEL_PROPS } from 'utils/mixpanel'
import { EVENTS, trackEvent } from 'utils/tracking/events-tracker'

interface GrowthbookFeaturePlanValue {
  plan_prefix: string
  plan_interval: string
  plan_region: string
  experiment?: 'others'
  enabled: boolean
  start_date: string
  end_date: string
}

export const trackMonthlyExperiment = ({ user }: { user: User }) => {
  const featureStatusNewMonthlyPriceV2ExperimentDate =
    growthBook.getFeatureValue<GrowthbookFeaturePlanValue | null>(
      growthbookFeatures.NEW_MONTHLY_PRICE,
      null,
    )

  if (!featureStatusNewMonthlyPriceV2ExperimentDate) {
    return
  }

  const isWithinExperimentPeriod = isWithinDateRange({
    startDate: featureStatusNewMonthlyPriceV2ExperimentDate.start_date,
    endDate: featureStatusNewMonthlyPriceV2ExperimentDate.end_date,
    date: (user?.created_at ?? 0) * 1000,
    timeZone: 'America/Los_Angeles',
  })

  growthBook.setAttributes({
    id: getGrowthbookUserId(),
    userId: user.id,
    tier: user?.tier || 'unlogged',
    affiliation: user?.affiliation || false,
    planInterval: user ? user?.subscription?.planInterval || 'free' : 'unknown',
    shouldShowNewTierOne: !user?.tier || isWithinExperimentPeriod,
  })

  const featureStatusNewMonthlyPriceV2 =
    growthBook.getFeatureValue<GrowthbookFeaturePlanValue | null>(
      growthbookFeatures.NEW_MONTHLY_PRICE,
      null,
    )

  if (!featureStatusNewMonthlyPriceV2) {
    return
  }

  const isMonthlyTier1PriceExperimentEnabled =
    getMonthlyTier1PriceExperimentEnabled(
      featureStatusNewMonthlyPriceV2?.experiment,
      featureStatusNewMonthlyPriceV2.enabled,
    )

  Mixpanel.registerAndSetPeople({
    [MIXPANEL_PROPS.MONTHLY_TIER_1_PRICE_EXPERIMENT.name]:
      isMonthlyTier1PriceExperimentEnabled,
  })

  if (isMonthlyTier1PriceExperimentEnabled !== 'out-of-experiment') {
    const hotjarEvent =
      isMonthlyTier1PriceExperimentEnabled === 'true'
        ? EVENTS.MONTHLY_TIER_1_PRICE_EXPERIMENT_VARIANT
        : EVENTS.MONTHLY_TIER_1_PRICE_EXPERIMENT_CONTROL

    trackEvent({
      event: hotjarEvent,
    })
  }

  return isMonthlyTier1PriceExperimentEnabled
}
